import ScaleOutlinedIcon from '@mui/icons-material/ScaleOutlined';
import Stack from '@mui/material/Stack';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';
import InputNumberEditableOnHover from '@/components/common/forms/InputNumberEditableOnHover';
import LabelChip from '@/components/common/LabelChip';
import Title from '@/components/common/Title';
import type {InventoryPlot} from '@/domain/entities/InventoryPlot';
import type UserPermissions from '@/domain/useCases/userPermissions';

//TYPES
type Props = {
  permissions: UserPermissions;
  inventoryPlot: InventoryPlot;
  onAppraiserWeightChange: (appraiserWeight: number) => void;
};

const InventoryPlotRealWeight: FC<Props> = ({permissions, inventoryPlot, onAppraiserWeightChange}) => {
  const {t} = useTranslation();

  const {appraiserWeight} = inventoryPlot;

  const canEdit = permissions.hasPermissionToEditInventoryPlotRealWeight();

  return (
    <>
      <Stack>
        <Title
          size="h6"
          label={t('inventoryPlots.appraiserWeight')}
          subtitleLabel={canEdit ? t('inventoryPlots.canEdit') : ''}
        />
      </Stack>
      <LabelChip value={t('inventoryPlots.weight')} icon={ScaleOutlinedIcon}>
        <InputNumberEditableOnHover
          editable={canEdit}
          value={Number(appraiserWeight.toFixed(2))}
          onSave={onAppraiserWeightChange}
          unit="Tn"
        />
      </LabelChip>
    </>
  );
};
export default InventoryPlotRealWeight;
